import styled from 'styled-components';

export const Container = styled.div`
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding: ${({ $topOffset }) => ($topOffset ? '120px' : '24px')} 16px 80px;

  @media (min-width: 768px) {
    padding-left: 24px;
    padding-right: 24px;
  }
`;

export const ContentWrapper = styled.div`
  box-sizing: border-box;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
`;

export const SearchBarWrapper = styled.div`
  margin-bottom: 32px;
`;

export const Section = styled.section`
  margin-bottom: 40px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const SectionTitle = styled.h2`
  margin: 0 0 20px;
  font: normal 600 18px/24px inter, sans-serif;
  color: ${({ theme }) => theme.colors.greys.darkest};
`;

export const CardsGrid = styled.div`
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(auto-fill, 425px);
`;
